import React from 'react'
import { Icon, IconButton, Menu, MenuItem } from 'react-mdl'
import './style.css'

export default class LadderMenu extends React.Component {

    state = {
        archived: [],
        errorOccurred: false
    }

    componentDidMount() {
      this.loadArchivedLadders();
    }

    loadArchivedLadders() {
        fetch('https://ladder.slashdiablo.net/ladder/archived')
        .then((response) => {
            if (response.status >= 400) {
                throw new Error("Something went terribly wrong");
            }
            return response.json();
        })
        .then((response) => {
            if(response.ladders) {
                this.setState({
                    archived: response.ladders.reverse()
                });
            }
        })
        .catch((e) => {
            this.setState({
                errorOccurred: true
            });
        });
    }

    render() {
        if(!this.state.archived) {
            return (
                <div className="ladder-menu">
                    <IconButton name="dehaze" id="ladder-menu" />
                </div>
            );
        }

        return (
            <div className="ladder-menu">
                <IconButton name="dehaze" id="ladder-menu" />
                <Menu target="ladder-menu">
                    <MenuItem><a href="/exphardcore/overall"><Icon name="timelapse"></Icon> Current ladder</a></MenuItem>
                    { this.state.archived.map((ladder) =>
                        <MenuItem key={ladder.id}><a href={"/archived-ladder/"+ladder.id+"/exp"}><Icon name="history"></Icon> {ladder.name}</a></MenuItem>
                    )}
                </Menu>
            </div>
        );
    }
};



/** WEBPACK FOOTER **
 ** ./src/components/ladder-menu/index.jsx
 **/